import { Theme, ThemeUIContextValue } from "theme-ui";

import {
  borderWidths,
  breakpoints,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  linkStyles,
  radii,
  rootStyles,
  shadows,
  sizes,
  space,
  zIndices,
  badges,
  buttons,
  cards,
  forms,
  links,
  layouts,
  IExtendedColors,
  textStyles,
  alerts,
  iconButtons,
  messages,
} from "./styles";
import { NavLinkProps } from "react-router-dom";
import React from "react";
import { TEXT_VARIANTS } from "./styles";

export type THeadingLevel = `h${1 | 2 | 3 | 4 | 5 | 6}`;
export type THeadingVariants = "mega" | THeadingLevel;

declare module "theme-ui" {
  interface ColorModesScale extends IExtendedColors {}
  interface ColorMode {
    colors: IExtendedColors;
  }
  interface ExactContextValue extends Omit<ThemeUIContextValue, "theme"> {
    theme: ExactTheme;
  }
  type BoxShadow = typeof shadows;
  type BorderRadius = typeof radii;

  interface BoxOwnProps extends Partial<NavLinkProps> {}

  interface HeadingProps {
    variant?: THeadingVariants | `text.${keyof typeof TEXT_VARIANTS}`;
    as?: THeadingLevel | React.ElementType;
  }
}

export const makeTheme = <T extends Theme>(t: T) => t;

export const theme = makeTheme({
  borderWidths,
  breakpoints,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  sizes,
  shadows,
  space,
  radii,
  zIndices,
  /** Component styles */
  links,
  cards,
  forms,
  text: textStyles,
  badges,
  buttons: {
    ...buttons,
    icon: {
      ...iconButtons,
    },
  },
  alerts,
  messages,
  layout: {
    ...layouts,
  },
  // Element styles (for example h1, h1, p etc.
  styles: {
    root: rootStyles,
    a: linkStyles,
    b: {
      fontWeight: "semibold",
    },
  },
});

export type ExactTheme = typeof theme;
